import { computed } from 'vue'
import { createGlobalState, until } from '@vueuse/core'
import { Role } from '@/opendoors-api/client'
import { useUser } from './useUser'

export const useRole = createGlobalState(() => {
  const { user, loading: userLoading } = useUser()
  const roles = computed(() => user.value?.roles)
  const isAdmin = computed(() => roles.value?.includes(Role.ADMIN))
  const isCustomer = computed(() => roles.value?.includes(Role.CUSTOMER))
  const isDeurgetest = computed(() => roles.value?.includes(Role.DEURGETEST))
  const loading = computed(() => {
    return userLoading.value && roles.value === undefined
  })

  const hasRole = async (...requiredRoles: Role[]): Promise<Role | false> => {
    const userRoles = await until(roles).toMatch((value) => !!value) // https://github.com/vueuse/vueuse/issues/3740
    for (const role of userRoles) {
      if (requiredRoles.includes(role as Role)) {
        return role as Role
      }
    }
    return false
  }
  return { isAdmin, isCustomer, isDeurgetest, loading, roles, hasRole }
})
